// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ``, "",{"version":3,"sources":[],"names":[],"mappings":"","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"whiteColor": `var(--color-white)`,
	"oemLicenseKeysBulkImportModal": `var(--color-grey-950)`,
	"homeViewTierTypeLabelTextColor": `var(--color-grey-950)`,
	"homeCurrentPlanRedColor": `var(--color-purple-100)`,
	"homeCurrentPlanBlueColor": `var(--color-sky-100)`,
	"homeCurrentPlanYellowColor": `var(--color-yellow-100)`,
	"homeCurrentPlanIconRedColor": `var(--color-purple-800)`,
	"homeCurrentPlanIconBlueColor": `var(--color-sky-700)`,
	"homeCurrentPlanIconYellowColor": `var(--color-orange-300)`,
	"homeCardTextColor": `var(--color-grey-950)`,
	"homeCardVersionColor": `var(--color-grey-800)`,
	"homeCardBackgroundColor": `var(--color-grey-100)`,
	"homeCardBorderColor": `var(--color-grey-150)`,
	"homeCardNameColor": `var(--color-grey-950)`,
	"homeWireIconColor": `var(--color-purple-900)`,
	"homeWireIconBackgroundColor": `var(--color-purple-300)`,
	"activeBackgroundColor": `var(--color-blue-700)`,
	"primaryButtonBackgroundColor": `var(--color-blue-700)`,
	"secondaryButtonForegroundColor": `var(--color-blue-700)`,
	"bannerBackgroundColor": `rgba(13,27,181,.5)`,
	"linkTextColor": `var(--color-blue-700)`,
	"primaryButtonBackgroundHoverColor": `var(--color-blue-800)`,
	"secondaryButtonBackgroundHoverColor": `var(--color-purple-200)`,
	"destructiveButtonBackgroundHoverColor": `var(--color-red-900)`,
	"primaryButtonBackgroundActiveColor": `var(--color-blue-900)`,
	"destructiveButtonBackgroundColor": `var(--color-red-950)`,
	"navigationButtonBackgroundActiveColor": `var(--color-blue-200)`,
	"chartNegativeColor": `var(--color-red-500)`,
	"chartPositiveColor": `var(--color-green-500)`,
	"chartNeutralColor": `var(--color-grey-500)`,
	"errorBackgroundColor": `var(--color-red-800)`,
	"errorBorderColor": `var(--color-red-800)`,
	"errorTextColor": `var(--color-red-800)`,
	"deleteScheduleLinkColor": `#db2828`,
	"errorWrapperBackgroundColor": `var(--color-red-400)`,
	"warningBackgroundColor": `var(--color-orange-800)`,
	"warningTextColor": `var(--color-orange-800)`,
	"secondaryWarningBackgroundColor": `var(--color-yellow-700)`,
	"secondaryWarningBorderColor": `var(--color-yellow-700)`,
	"successBorderColor": `var(--color-green-500)`,
	"successTextColor": `var(--color-green-500)`,
	"pageBackgroundColor": `var(--color-grey-100)`,
	"wrapperBackgroundColor": `var(--color-blue-200)`,
	"urlSectionBackgroundColor": `var(--color-blue-200)`,
	"wrapperBorderColor": `var(--color-blue-500)`,
	"modelBoxBackgroundColor": `var(--color-grey-150)`,
	"contentBackgroundColor": `var(--color-white)`,
	"secondaryButtonBackgroundColor": `var(--color-white)`,
	"textColor": `var(--color-grey-900)`,
	"textGreyColor": `var(--color-grey-800)`,
	"primaryButtonForegroundColor": `var(--color-white)`,
	"bannerForegroundColor": `var(--color-grey-900)`,
	"chartOutlineColor": `var(--color-grey-1000)`,
	"modalOverlayColor": `rgba(76,76,76,.15)`,
	"contentDividerColor": `var(--color-grey-500)`,
	"contentBorderColor": `var(--color-grey-150)`,
	"nestedContentBorderColor": `var(--color-grey-500)`,
	"disabledButtonBackgroundColor": `var(--color-grey-500)`,
	"disabledButtonForegroundColor": `var(--color-white)`,
	"inputHintColor": `var(--color-grey-500)`,
	"inputBackgroundColor": `var(--color-white)`,
	"hoverBackgroundColor": `var(--color-grey-100)`,
	"toggleCheckedBackgroundColor": `var(--color-blue-500)`,
	"toggleUncheckedBackgroundColor": `var(--color-grey-500)`,
	"chartFirstSet": `var(--color-blue-700)`,
	"chartSecondSet": `#ab446c`,
	"chartThirdSet": `#253a6b`,
	"chartForthSet": `#5f96bc`,
	"chartFifthSet": `#a56d35`,
	"chartSixthSet": `#7a314d`,
	"chartSeventhSet": `#466c86`,
	"chartEighthSet": `#ca6b0c`,
	"chartNinthSet": `#2490cb`,
	"chartTenthSet": `#c34578`,
	"chartEleventhSet": `#446fb1`,
	"chartTwelfthSet": `var(--color-orange-800)`,
	"optional": `var(--color-grey-700)`,
	"disabledTextColor": `var(--color-grey-700)`,
	"colorPickerBlack": `var(--color-grey-1000)`,
	"iconFillColor": `var(--theme-icon-fill-default)`,
	"sortIconRegularColor": `var(--color-grey-500)`,
	"sortIconHoverColor": `var(--color-blue-700)`,
	"sortIconActiveColor": `var(--color-grey-900)`,
	"diamondTierBannerBorderColor": `var(--color-pink-700)`,
	"starTierBannerBorderColor": `var(--color-purple-900)`,
	"chartSuccessColor": `var(--color-green-600)`,
	"chartFailColor": `var(--color-red-800)`,
	"textFieldColor": `var(--color-grey-500)`,
	"focusOutlineColorButton": `#d661e5`,
	"tooltipTextColor": `var(--color-white)`,
	"tooltipBackgroundColor": `var(--color-grey-900)`,
	"chipBackgroundColor": `var(--color-grey-150)`,
	"chipContentColor": `var(--color-grey-1000)`,
	"chipUserIconColor": `var(--color-grey-1000)`,
	"successIconColor": `var(--color-green-700)`,
	"errorIconColor": `var(--color-red-800)`,
	"localBannerBackgroundColor": `var(--color-blue-100)`,
	"localBannerBorderColor": `var(--color-grey-500)`,
	"errorBannerBackgroundColor": `var(--color-red-100)`,
	"localBannerTextColor": `var(--color-grey-900)`,
	"successBadgeTextColor": `var(--color-green-700)`,
	"warningBadgeBackgroundColor": `var(--color-yellow-200)`,
	"warningBadgeTextColor": `var(--color-yellow-900)`,
	"errorBadgeBackgroundColor": `var(--color-red-150)`,
	"errorBadgeTextColor": `var(--color-red-800)`,
	"infoBadgeBackgroundColor": `var(--color-blue-200)`,
	"infoBadgeTextColor": `var(--color-grey-1000)`,
	"infoIconBackgroundColor": `var(--color-grey-800)`,
	"neutralBadgeBackgroundColor": `var(--color-grey-150)`,
	"neutralBadgeTextColor": `var(--color-grey-800)`,
	"strokeColor": `var(--color-blue-200)`,
	"textHighlightForegroundColor": `linear-gradient(0deg, rgba(250, 200, 16, 0.3) 0%, rgba(250, 200, 16, 0.3) 100%)`,
	"textHighlightBackgroundColor": `var(--color-white)`,
	"skeletonLoaderBackgroundColor": `var(--color-grey-150)`,
	"fourthLevelTierBackgroundColor": `var(--color-purple-900)`,
	"defaultStarColor": `var(--color-green-800)`,
	"addOnsCheckmarkColor": `var(--color-green-500)`,
	"warningBannerBackgroundColor": `var(--color-yellow-100)`,
	"warningBannerBorderColor": `var(--color-yellow-150)`,
	"warningBannerTextColor": `var(--color-grey-1000)`,
	"warningIconBackgroundColor": `var(--color-yellow-700)`,
	"warningIconExclamationColor": `var(--color-grey-1000)`,
	"hoverColor": `rgba(var(--color-blue-700), 0.06)`,
	"navigationButtonBackgroundHoverColor": `var(--color-blue-150)`,
	"conditionToggleButtonBackgroundColor": `var(--color-grey-150)`,
	"conditionToggleButtonBorderColor": `var(--color-grey-500)`,
	"conditionTableBackgroundColor": `var(--color-grey-100)`,
	"conditionTableBorderColor": `var(--color-grey-500)`,
	"conditionTableNestedBackgroundColor": `var(--color-grey-150)`,
	"modularPurpleColor": `var(--color-purple-900)`,
	"modularBackgroundPurpleColor": `var(--color-purple-200)`,
	"readyToUseSkyBlueColor": `var(--color-sky-700)`,
	"readyToUseBackgroundBlueColor": `var(--color-sky-200)`,
	"readyToUseBorderBlueColor": `var(--color-sky-300)`,
	"modularBorderPurpleColor": `var(--color-purple-400)`,
	"integrationGreenColor": `var(--color-green-700)`,
	"integrationBorderGreenColor": `var(--color-green-500)`,
	"integrationBackgroundGreenColor": `var(--color-green-200)`,
	"descriptionTextColor": `var(--color-grey-800)`,
	"lightGreenBackgroundColor": `var(--color-green-200)`,
	"lightBlueBackgroundColor": `var(--color-blue-200)`,
	"errorBannerColor": `var(--color-red-100)`,
	"errorBannerTextColor": `var(--color-grey-900)`,
	"bannerIconBackgroundColor": `var(--color-red-800)`,
	"bannerIconColor": `var(--color-white)`,
	"accordianSuccessBackgroundColor": `var(--color-green-100)`,
	"accordianSuccessBorderColor": `var(--color-green-400)`,
	"accordianSuccessTextColor": `var(--color-green-800)`,
	"cardBorderColor": `var(--color-grey-500)`,
	"navigationListDividerColor": `var(--color-grey-500)`,
	"userDefinedErrorColor": `var(--color-orange-950)`,
	"ruleGreenColor": `#c0ecbf`,
	"ruleYellowColor": `#ffd95b`,
	"ruleBlueColor": `#b2d6ff`,
	"ruleRedColor": `#ffa395`,
	"rulePurpleColor": `#bbb6ff`,
	"ruleOrangeColor": `#f6ac81`,
	"rulePinkColor": `#f2bddc`,
	"ruleCyanColor": `#82cdda`,
	"ruleGrayColor": `#dad9d9`
};
export default ___CSS_LOADER_EXPORT___;
